import { render, staticRenderFns } from "./Admin-propietarios-edit.vue?vue&type=template&id=3ca50b23&"
import script from "./Admin-propietarios-edit.vue?vue&type=script&lang=js&"
export * from "./Admin-propietarios-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports